import { useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web";
import CircularProgress from "@mui/material/CircularProgress";

import styles from "./syles.module.scss";
import { Outlet, useLocation } from "react-router-dom";

const SinglePrivateRoute = () => {
  const { keycloak, initialized } = useKeycloak();

  const location = useLocation();
  const pathAtual = location.pathname;

  useEffect(() => {
    if (initialized && !keycloak.authenticated) {
      keycloak.login();
    }
  }, [initialized, keycloak]);

  if (!initialized) {
    return (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress size={100} />
      </div>
    );
  }

  return (
    <>
      <div className={styles.wrapper}>
        <main className={`${pathAtual === "/scheduler" && styles.notPadding}`}>
          {keycloak.authenticated ? <Outlet /> : null}
        </main>
      </div>
    </>
  );
};

export default SinglePrivateRoute;
